export const UPDATE_COURSES = "UPDATE_COURSES";
export const SET_COURSE = "SET_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const SET_LECTURE = "SET_LECTURE";
export const SELECT_LECTURE = "SELECT_LECTURE";
export const STUDENT_FETCH_START = "STUDENT_FETCH_START";
export const STUDENT_FETCH_SUCCESS = "STUDENT_FETCH_SUCCESS";
export const STUDENT_FETCH_FAILURE = "STUDENT_FETCH_FAILURE";

const StudentReducer = (state, action) => {
  switch (action.type) {
    case STUDENT_FETCH_START: {
      return { ...state, loading: true };
    }
    case STUDENT_FETCH_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }
    case STUDENT_FETCH_SUCCESS: {
      return { ...state, loading: false, error: null };
    }
    case UPDATE_COURSES: {
      // convert the array of courses to an object with UUIDs as keys
      const map = new Map(action.payload.map((c) => [c.uuid, c]));

      let courses = Object.fromEntries(map);
      courses = state.courses ? Object.assign(courses, state.courses) : courses;

      return { ...state, courses, loading: false, error: null };
    }
    case SET_COURSE: {
      const { uuid, lectures } = action.payload;

      // convert the array of courses to an object with UUIDs as keys
      const map = new Map(lectures.map((l) => [l.uuid, l]));

      return {
        ...state,
        courses: {
          ...state.courses,
          [uuid]: {
            ...action.payload,
            lectures: Object.fromEntries(map),
          },
        },
        loading: false,
        error: null,
      };
    }
    case DELETE_COURSE: {
      const uuid = action.payload;

      delete state.courses[uuid];

      return { ...state, loading: false, error: null };
    }
    case SET_LECTURE: {
      const {
        courseUUID,
        lecture,
        lecture: { uuid },
      } = action.payload;

      return {
        ...state,
        loading: false,
        error: null,
        courses: {
          ...state.courses,
          [courseUUID]: {
            ...state.courses[courseUUID],
            lectures: {
              ...state.courses[courseUUID].lectures,
              [uuid]: lecture,
            },
          },
        },
      };
    }
    case SELECT_LECTURE: {
      return { ...state, currentLecture: action.payload, loading: false, error: null };
    }
    default:
      return state;
  }
};

export default StudentReducer;
